import React, { useState } from 'react';
import { Button } from './ui/Button';
import { JobApplicationForm, Job } from './JobApplicationForm';
export function JobsCTA() {
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const jobs: Job[] = [{
    emoji: '🍞',
    title: 'Bagare',
    subtitle: 'Heltid / Halvtid / Deltid',
    description: 'Älskar du hantverket, är nyfiken på att utvecklas och vill vara med och forma ett bageri med höga ambitioner? Vi söker en bagare – oavsett om du är erfaren eller redo att visa framfötterna – som vill växa tillsammans med oss.'
  }, {
    emoji: '🏪',
    title: 'Platschef',
    subtitle: 'Heltid',
    description: 'Är du en närvarande ledare som tycker om människor, service och att skapa struktur i vardagen? Vi söker en platschef som vill leda med värme, föregå med gott exempel och vara med och utveckla hela verksamheten.'
  }, {
    emoji: '🧁',
    title: 'Servicepersonal',
    subtitle: 'Deltid / Extra / Heltid',
    description: 'Tycker du om mötet med människor och ser varje gäst som en möjlighet att göra något extra? Vi söker servicepersonal som vill skapa personliga och välkomnande upplevelser – varje dag.'
  }];
  return <section className="w-full py-16 px-4 flex flex-col items-center animate-in slide-in-from-bottom-8 duration-1000 delay-300 fill-mode-backwards" data-id="element-145">
      <div className="max-w-6xl mx-auto space-y-12 w-full" data-id="element-146">
        <div className="text-center space-y-4 max-w-2xl mx-auto" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A1A1A] tracking-tight" data-id="element-148">
            Vill du bli en del av vårt team?
          </h2>
          <p className="text-lg text-[#1A1A1A]/80 leading-relaxed" data-id="element-149">
            Vi letar alltid efter passionerade bagare och konditorer som vill
            skapa magi tillsammans med oss.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-150">
          {jobs.map((job, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-[#C5A55A]/15 flex flex-col items-center text-center h-full hover:shadow-md transition-shadow duration-300" data-id="element-151">
              <div className="text-4xl mb-4" data-id="element-152">{job.emoji}</div>
              <h3 className="text-2xl font-serif text-[#1A1A1A] mb-1" data-id="element-153">
                {job.title}
              </h3>
              <p className="text-[#C5A55A] font-medium text-sm tracking-wide uppercase mb-4" data-id="element-154">
                {job.subtitle}
              </p>
              <p className="text-[#1A1A1A]/70 text-sm leading-relaxed mb-8 flex-grow" data-id="element-155">
                {job.description}
              </p>
              <Button variant="outline" className="w-full mt-auto" onClick={() => setSelectedJob(job)} data-id="element-156">
                Läs mer & ansök
              </Button>
            </div>)}
        </div>

        <div className="text-center pt-4" data-id="element-157">
          <p className="text-sm text-[#1A1A1A]/50" data-id="element-158">
            Hittar du inte en tjänst som passar? Skicka gärna en spontanansökan!
          </p>
        </div>
      </div>

      {/* Application Form Modal */}
      {selectedJob && <JobApplicationForm job={selectedJob} onClose={() => setSelectedJob(null)} data-id="element-159" />}
    </section>;
}